import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { useSearchParams } from 'react-router-dom';

import LinkOpenBanking from './LinkOpenBanking';
import { LinkOpenBankingDocumentRequirementContent } from './LinkOpenBankingDocumentRequirementContent/LinkOpenBankingDocumentRequirementContent';
import styles from './TrueLayer.module.css';
import { TTrueLayerAlertStatus } from '../../../types';
import DocumentRequirement from '../DocumentRequirement/DocumentRequirement';

type TProps = {
  setAlertStatus: (status: TTrueLayerAlertStatus) => void;
};

const OpenBanking = ({ setAlertStatus }: TProps) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const statusCode = searchParams.get('status_code');
    const errorDetail = searchParams.get('error_detail');

    if (statusCode) {
      if (statusCode === '200') {
        tracking.ampli.openBankingLinkedSuccessfully();
        setAlertStatus('success');
      }
      if (statusCode === '500' && errorDetail === 'access_denied') {
        tracking.ampli.openBankingLinkingCancelled();
        setAlertStatus('cancel');
      }
      if (statusCode === '500' && errorDetail !== 'access_denied') {
        tracking.ampli.openBankingLinkingFailed();
        setAlertStatus('failure');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <DocumentRequirement
      className={styles.documentRequirement}
      documentType="bank statement"
      customButton={<LinkOpenBanking />}
    >
      <LinkOpenBankingDocumentRequirementContent />
    </DocumentRequirement>
  );
};

export default OpenBanking;
